import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PurchaseApiService } from 'src/app/core/services/http/purchase-api.service';
import { MarketingStrategy } from 'src/app/shared/models/marketingStrategy.models';
import { OrderModel } from 'src/app/shared/models/order.models';
import { SurveyPurchaseModel, SurveyPurchaseOptionsModel } from 'src/app/shared/models/surveyMarketingStrategy.models';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-purchase-page',
  templateUrl: './purchase-page.component.html',
})
export class PurchasePageComponent implements OnInit {
  marketingDollarsToUse: number = 0;
  marketingDollars!: number;
  paymentAmount!: number;
  @Output() purchaseComplete: EventEmitter<any> = new EventEmitter();
  @Output() purchaseCanceled: EventEmitter<any> = new EventEmitter();
  @Input() purchaseModel!: SurveyPurchaseModel;
  selectedPurchaseOption!: number;
  submittingOrder: boolean = false;
  error: boolean = false;
  numberOfSeats: number = 0;
  paymentForm!: FormGroup;

  constructor(private purchaseApiService: PurchaseApiService) { }

  initForm(): void {
    this.paymentForm = new FormGroup({
      'selectedPurchaseOption': new FormControl(null),
      'marketingDollarsToUse': new FormControl(null)
    });
  }

  ngOnInit(): void {
    this.initForm();
    if (this.purchaseModel.PurchaseOptions.length === 1) {
      this.selectedPurchaseOption = 0;
      this.marketingDollarsToUse = 0;
      this.getPaymentAmount();
    }
  }

  getPaymentAmount() {

    if (this.purchaseModel.PurchaseOptions[this.selectedPurchaseOption]) {
      const preMarketingDollarPrice = this.purchaseModel.PurchaseOptions[this.selectedPurchaseOption].Amount;

      if (this.marketingDollarsToUse < 0) {
        this.marketingDollarsToUse = 0;
      }

      if (this.marketingDollarsToUse > this.marketingDollars) {
        this.marketingDollarsToUse = this.marketingDollars;
      }

      if (this.marketingDollarsToUse > preMarketingDollarPrice) {
        this.marketingDollarsToUse = preMarketingDollarPrice;
      }

      this.paymentAmount = preMarketingDollarPrice - this.marketingDollarsToUse;
    }
  }

  purchase() {
    const model = this.purchaseModel.PurchaseOptions[this.selectedPurchaseOption];
    this.submittingOrder = true;
    const order: any = {
      Description: model.Description,
      PaymentAmount: this.paymentAmount,
      ArcSurveyRenewalId: this.purchaseModel.ArcSurveyRenewalId,
      MarketingDollarsUsed: this.marketingDollarsToUse,
      MarketingStrategy: this.purchaseModel.PurchaseOptions[this.selectedPurchaseOption].MarketingStrategy,
      Total: this.purchaseModel.PurchaseOptions[this.selectedPurchaseOption].Amount,
      Frequency: 0,
      AdditionalInfo: {
        NumberOfSeats: this.numberOfSeats
      }
    };

    if (order.ArcSurveyRenewalId) {
      this.purchaseApiService.purchaseRenewal(order).subscribe(res => {
        this.submittingOrder = false;

        let returnObj = {};
        if (this.paymentAmount > 0) {
          window.open(res.payUrl, '_blank');
          returnObj = {
            orderId: res.orderId,
            surveyRenewalId: order.ArcSurveyRenewalId,
            action: 'Order Submitted',
            paymentAmount: this.paymentAmount
          };
        } else {
          returnObj = {
            orderId: res.orderId,
            surveyRenewalId: order.ArcSurveyRenewalId,
            action: 'Order Completed',
            paymentAmount: this.paymentAmount
          };
        }
        this.purchaseComplete.emit(returnObj);
      });
    } else {
      this.purchaseApiService.purchase(order).subscribe(res => {

        this.submittingOrder = false;
        if (this.paymentAmount > 0) {
          window.open(res, '_blank');
        }
        this.purchaseComplete.emit({ paymentAmount: this.paymentAmount });
      }, error => {
        console.log(error);
        this.submittingOrder = false;
        this.error = true;
        this.purchaseCanceled.emit();
      });
    }
  }

  goBack() {
    this.purchaseCanceled.emit();
  }

}
